import { AxiosInstance } from 'axios';
import * as RoomMoveReportService from './services';

export type RoomMoveReportServiceType = ReturnType<typeof RoomMoveReportService.exportPDF>;

export const initRoomMoveReportService = (axios: AxiosInstance): RoomMoveReportServiceType =>
  RoomMoveReportService.exportPDF(axios);
